import { CheckboxItem as IdskCheckboxItem } from '@mc-ui/idsk-react-components';

import { withReactHookForm } from '../hoc/withReactHookForm';

export const CheckboxItem = withReactHookForm(IdskCheckboxItem);
